import { Injectable } from '@angular/core';
import { IStaticDropdownData } from '../../models/common/interfaces/IStaticDropdownData';
import { StaticDropdownAPIService } from '../api/static-dropdown-api.service';
import { DropDownItem } from '../../models/dtos';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StaticDropdownService {

  private data$: Observable<IStaticDropdownData> | null = null;

  constructor(private readonly staticDropdownAPIService: StaticDropdownAPIService) {}

  loadData(): void {
    this.getData$().pipe(take(1)).subscribe();
  }

  private getData$(): Observable<IStaticDropdownData> {
    if (!this.data$) {
      this.data$ = this.staticDropdownAPIService.loadData().pipe(
        take(1),
        catchError((error) => {
          console.error('Error loading static dropdown data:', error);
          return of({} as IStaticDropdownData);
        })
      );
    }

    return this.data$;
  }

  private getData<K extends keyof IStaticDropdownData>(key: K): Observable<DropDownItem[]> {
    return this.getData$().pipe(
      map((data) => (data?.[key] as DropDownItem[]) ?? [])
    );
  }

  getBillingPeriods(): Observable<DropDownItem[]> {
    return this.getData('billingPeriods');
  }

  getCountries(): Observable<DropDownItem[]> {
    return this.getData('countries');
  }

  getProjectUnits(): Observable<DropDownItem[]> {
    return this.getData('projectUnits');
  }

  getCalculationMethods(): Observable<DropDownItem[]> {
    return this.getData('calculationMethods');
  }

  getSiteDistances(): Observable<DropDownItem[]> {
    return this.getData('siteDistances');
  }

  getEscalationTypes(): Observable<DropDownItem[]> {
    return this.getData('escalationTypes');
  }

  getLocation(): Observable<DropDownItem[]> {
    return this.getData('location');
  }

  getOnlineOrPhoneOptions(): Observable<DropDownItem[]> {
    return this.getData('onlineOrPhoneOptions');
  }

  getOnsiteOptions(): Observable<DropDownItem[]> {
    return this.getData('onsiteOptions');
  }

  getHoursOfCoverages(): Observable<DropDownItem[]> {
    return this.getData('hoursOfCoverages');
  }

  getPreferenceMaterials(): Observable<DropDownItem[]> {
    return this.getData('preferenceMaterials');
  }

  getPropertiesMaterials(): Observable<DropDownItem[]> {
    return this.getData('propertiesMaterials');
  }

  getLabors(): Observable<DropDownItem[]> {
    return this.getData('labors');
  }

  getSubcontractors(): Observable<DropDownItem[]> {
    return this.getData('subcontractors');
  }

  getMiscellaneous(): Observable<DropDownItem[]> {
    return this.getData('miscellaneous');
  }

  getTravels(): Observable<DropDownItem[]> {
    return this.getData('travels');
  }

  getPriceUnderCategories(): Observable<DropDownItem[]> {
    return this.getData('priceUnderCategories');
  }

  getIdentifier(): Observable<DropDownItem[]> {
    return this.getData('identifier');
  }

  getMaterialListingOptionsByAreaPPM(): Observable<DropDownItem[]> {
    return this.getData('materialListingOptionsByAreaPPM');
  }

  getMaterialListingOptionsByArea(): Observable<DropDownItem[]> {
    return this.getData('materialListingOptionsByArea');
  }

  getMaterialListingOptions(): Observable<DropDownItem[]> {
    return this.getData('materialListingOptions');
  }
}
  